import Vue from 'vue';
import { apiPath } from '../constants';

const Apps = Vue.resource(
  `${apiPath}/apps{/packageName}{/type}/`,
  {},
  {
    getSupportInfo: { method: 'GET', params: { type: 'support-info' } },
    updateSupportInfo: { method: 'PUT', params: { type: 'support-info' } },
    getBasicInfo: { method: 'GET', params: { type: 'basic-info' } },
    getRSAKey: { method: 'GET', params: { type: 'rsa-key' } },
    getDynamicPriceKey: {
      method: 'GET',
      params: { type: 'dynamic-price-key' },
    },
    renewDynamicPriceKey: {
      method: 'PUT',
      params: { type: 'dynamic-price-key' },
    },
    getVideoShots: { method: 'GET', params: { type: 'video-shots' } },
    updateVideoShots: { method: 'PUT', params: { type: 'video-shots' } },
    getScreenshots: { method: 'GET', params: { type: 'screenshots' } },
    updateScreenshots: { method: 'PUT', params: { type: 'screenshots' } },
    getPromoScreenshots: {
      method: 'GET',
      params: { type: 'promotion-screenshots' },
    },
    updatePromoScreenshots: {
      method: 'PUT',
      params: { type: 'promotion-screenshots' },
    },
    uploadScreenshots: {
      method: 'POST',
      params: { type: 'upload-screenshot' },
      showProgressBar: false,
    },
    uploadPromoScreenshots: {
      method: 'POST',
      params: { type: 'upload-promotion-screenshot' },
      showProgressBar: false,
    },
    uploadIcon: { method: 'POST', params: { type: 'icon' } },
    deleteCover: { method: 'DELETE', params: { type: 'cover' } },
    updateBasicInfo: { method: 'PUT', params: { type: 'basic-info' } },
    requestEsraRating: {
      method: 'POST',
      url: `${apiPath}/apps{/packageName}/esra-rating/request/`,
    },
    updateAuthor: { method: 'PUT', params: { type: 'developer' } },
    updatePrice: { method: 'PUT', params: { type: 'price' } },
    getProducts: { method: 'GET', params: { type: 'products' } },
    getPurchases: { method: 'GET', params: { type: 'purchases' } },
    getSubPurchases: {
      method: 'GET',
      params: { type: 'subscription-purchases' },
    },
    getPurchasesCsvByMonth: {
      method: 'GET',
      params: { type: 'purchases-csv' },
    },
    getRefundedPurchasesCsvByMonth: {
      method: 'GET',
      params: { type: 'refunded-purchases-csv' },
    },
    getSubscriptionPurchasesCsvByMonth: {
      method: 'GET',
      params: { type: 'subscription-purchases-csv' },
    },
    modifyPublishRules: {
      method: 'PUT',
      params: { type: 'publish-rules' },
    },
  },
);

export default Apps;
